import React from 'react'
import { styled } from '../../stitches/stitches.config'

type Props = {
  children: React.ReactNode
}

const FloatingFooter: React.FC<Props> = (props) => {
  return <Container {...props} />
}

export default FloatingFooter

const Container = styled('div', {
  position: 'absolute',
  display: 'flex',
  left: 0,
  right: 0,
  bottom: 0,
  width: '100%',
  padding: '12px 16px',
  overflow: 'hidden',
})
